module.exports = __webpack_public_path__ + "img/chat-flame.916e1f9.png";